// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3HjUl","form":"styles_form__35myY"};